import React, { useState } from 'react';
import PropTypes, { object } from 'prop-types';

import {
  Text,
  WithTooltip,
  Button,
  Icon,
  AdditionalModal
} from 'components/common/Elements/Elements';
import BarTooltip from '../BarTooltip/BarTooltip';
import AdditionalContent from '../AdditionalContent/AdditionalContent';

import { calcPercent, isNull } from 'utils/common';

import classes from './Bars.module.scss';

const Bars = ({ data }) => {
  const [isOpenAdditional, setIsOpenAdditional] = useState(false);
  const [infoForAdditionalModal, setInfoForAdditionalModal] = useState({});

  const onOpenAdditionalModal = info => {
    setInfoForAdditionalModal(info);
    setIsOpenAdditional(true);
  };

  const progressValueStyle = (val, from, color) => {
    const getProgressValue = (val, from) =>
      from ? `${calcPercent(val, from)}%` : '0%';

    return {
      width: getProgressValue(val, from),
      backgroundColor: color
    };
  };

  return (
    <>
      <AdditionalModal
        isOpen={isOpenAdditional}
        setIsOpen={setIsOpenAdditional}
        info={infoForAdditionalModal}
      />
      <ul className={classes.box}>
        {data.map(item => (
          <li key={item.name} className={classes.item}>
            <Text>{item.name}:</Text>
            <Text className={classes.visually_hidden}>
              {`${item.score} from ${item.weight}`}
            </Text>
            <div className={classes.info}>
              <WithTooltip
                className={classes.tooltip}
                text={
                  <BarTooltip
                    name={item.name}
                    color={item.color}
                    percent={calcPercent(item.score, item.weight)}
                  />
                }
              >
                <div className={classes.progress}>
                  {!isNull(item.score) && (
                    <div
                      style={progressValueStyle(
                        item.score,
                        item.weight,
                        item.color
                      )}
                      className={classes.bar}
                    ></div>
                  )}
                </div>
              </WithTooltip>
              <div className={classes.active}>
                {isNull(item.score) ? (
                  <Text>NA</Text>
                ) : (
                  <>
                    <Text className={classes.percent}>
                      {calcPercent(item.score, item.weight)}%
                    </Text>
                    <Button
                      className={classes.button}
                      onClick={() =>
                        onOpenAdditionalModal({
                          data: item,
                          content: <AdditionalContent data={item} />
                        })
                      }
                      aria-label="additional information"
                    >
                      <Icon size="16px" icon="3dots" color="#525f7f" />
                    </Button>
                  </>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

Bars.propTypes = {
  data: PropTypes.arrayOf(object)
};

export default Bars;
